/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Sources_View_DetailsInputs */

const es_settings_sources_view_details = /** @type {(inputs: Settings_Sources_View_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver detalles`)
};

const en_settings_sources_view_details = /** @type {(inputs: Settings_Sources_View_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View details`)
};

/**
* | output |
* | --- |
* | "View details" |
*
* @param {Settings_Sources_View_DetailsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_sources_view_details = /** @type {((inputs?: Settings_Sources_View_DetailsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Sources_View_DetailsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_sources_view_details(inputs)
	return en_settings_sources_view_details(inputs)
});
export { settings_sources_view_details as "settings.sources.view_details" }